module.exports = __webpack_public_path__ + "static/media/2040320000.2ce60cb2.jpg";